import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { ArrowRight, Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";
import { StoryCard } from "@/components/stories/StoryCard";
import { fetchPublishedStories } from "@/lib/coachesQueries";

export function StoriesCarousel() {
  const { data } = useQuery({
    queryKey: ["stories", "featured"],
    queryFn: () => fetchPublishedStories({ limit: 6 }),
  });
  const stories = data ?? [];
  if (stories.length === 0) return null;

  return (
    <section className="mt-20">
      <div className="mb-6 flex flex-wrap items-end justify-between gap-3">
        <div>
          <h2 className="flex items-center gap-2 text-2xl font-bold tracking-tight md:text-3xl">
            <Sparkles className="h-6 w-6 text-gold" /> Real members, real impact
          </h2>
          <p className="mt-1 text-muted-foreground">
            Auto-generated from real giving — published with member consent.
          </p>
        </div>
        <Button asChild variant="outline">
          <Link to="/stories">All stories <ArrowRight className="ml-1 h-4 w-4" /></Link>
        </Button>
      </div>
      <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
        {stories.slice(0, 3).map((s) => <StoryCard key={s.user_id} story={s} />)}
      </div>
    </section>
  );
}
